import { menusUrl } from '../resources'
import common from '../commons/getRequest'

async function getMenusByRestaurant(restaurantId) {
    let url = `${menusUrl}/getactivemenusbyrestaurant/${restaurantId}`;
    let data;
    await common.getData(url)
                .then( response => {
                    data = response
                });
    return data;
}

async function getMenuDetailById(menuid) {

    let url = `${menusUrl}/getmenudetail/${menuid}`;
    let data;

    await common.getData(url)
                .then( response => {
                    data = response
                });
    return data;
}

export default {
    getMenusByRestaurant,
    getMenuDetailById
}